/**
 * API service for communicating with the backend
 */

import type { Tournament, Round, LeaderboardEntry, TournamentConfig, Player } from '../types';

const API_URL = import.meta.env.VITE_API_URL || 'https://pickleball-tournament-api.lawrencesalazardev.workers.dev/api';

export async function generateSchedule(
  players: Player[],
  config: TournamentConfig
): Promise<{ schedule: Round[] }> {
  const response = await fetch(`${API_URL}/generate-schedule`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ players, config })
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.error || 'Failed to generate schedule');
  }

  return response.json();
}

export async function submitScore(
  tournament: Tournament,
  roundIndex: number,
  matchId: string,
  teamAScore: number,
  teamBScore: number
): Promise<{ schedule: Round[]; leaderboard: LeaderboardEntry[] }> {
  const response = await fetch(`${API_URL}/submit-score`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      roundIndex,
      matchId,
      teamAScore,
      teamBScore,
      players: tournament.players,
      schedule: tournament.schedule,
      format: tournament.config.format
    })
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.error || 'Failed to submit score');
  }

  return response.json();
}

export async function getLeaderboard(
  tournament: Tournament
): Promise<{ leaderboard: LeaderboardEntry[] }> {
  const response = await fetch(`${API_URL}/leaderboard`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      players: tournament.players,
      schedule: tournament.schedule,
      format: tournament.config.format
    })
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.error || 'Failed to get leaderboard');
  }

  return response.json();
}